/* NOTE THAT These enums are interfaces are copied from the component library (component/utils/icons) */
export enum IconType {
  FontAwesome = 'FONT_AWESOME',
  NgZorro = 'NG_ZORRO'
}
